import type { FC } from "react";
import EllipsesLoader, { type EllipsesLoaderProps } from "../Ellipses";

export interface ComponentLoaderProps {
  className?: string;
  ellipsesLoaderProps?: EllipsesLoaderProps;
}

const ComponentLoader: FC<ComponentLoaderProps> = ({
  className = "",
  ellipsesLoaderProps,
}) => {
  return (
    <div
      aria-busy="true"
      aria-label="loading"
      className={`flex h-full w-full flex-1 items-center justify-center bg-white-300 ${className}`}
    >
      <EllipsesLoader className="!scale-125" {...ellipsesLoaderProps} />
    </div>
  );
};

export default ComponentLoader;
